/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { LinkProps } from "@tvg/fuse-link";
import { getSearchHREF } from "client/utils/helpers";
import React, { useCallback, useMemo } from "react";
import { StyledBrand, StyledLi } from "./brand.styles";
export interface BrandProps extends Omit<LinkProps, "onClick"> {
  brand: string;
  onClick: (brand: string) => void;
}

const Brand = ({ brand, onClick, ...props }: BrandProps) => {
  const handleClick = useCallback(() => {
    onClick(brand);
  }, [brand, onClick]);

  const href = useMemo(() => getSearchHREF(brand), [brand]);

  return (
    <StyledLi
      data-testid="brand-wrapper"
      data-cnstrc-item-section="Brands"
      data-cnstrc-item-id={brand}
      data-cnstrc-item-name={brand}
    >
      <StyledBrand
        {...props}
        href={href}
        size="medium"
        underline={false}
        onClick={handleClick}
      >
        {brand}
      </StyledBrand>
    </StyledLi>
  );
};

export default React.memo(Brand);
